import type { SVGProps } from 'react'

/**
 * The app.ordo.com app icon (its favicon): the charcoal "o" with its stem on
 * a white rounded tile. For the bare letter use `OrdoMark`; for the wordmark,
 * `OrdoLogo`.
 */
export function OrdoAppIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 504 504" {...props}>
      <rect width="504" height="504" rx="126" fill="#FFFFFF" />
      <path
        fill="#343434"
        d="M160.82,306.39c0-48.03,39.92-86.75,89.45-86.75s89.45,36.62,89.45,86.75-40.22,87.34-89.45,87.34-89.45-36.92-89.45-87.34ZM280.28,360.42c18.31-6,17.71-32.42,6.9-59.43-11.11-27.61-40.82-60.33-65.13-52.23-17.41,5.7-18.61,33.62-5.4,63.93,12.61,29.12,39.92,55.53,63.63,47.73Z"
      />
      <path
        fill="#343434"
        d="M243.1,187.64c-3.01-.02-6.35-.17-10-.96-7.95-1.73-10.62-5.35-9.54-13.49,1.1-8.3,2.86-16.51,4.16-24.78,2.04-13.03.9-25.87-2.16-38.66-1.36-5.68-2.22-11.52-2.73-17.34-.45-5.2,1.62-8.34,6.64-9.89,10.54-3.27,20.72-3.44,31.35-.67,5.69,1.49,7.68,4.8,7.29,10.66-.22,3.19-.45,6.51-1.45,9.5-5.46,16.22-4,32.48-1.11,48.88,1.33,7.55,1.98,15.23,2.59,22.88.5,6.32-1.48,9.25-7.34,11.66-2.05.84-4.25,1.47-6.44,1.75-3.31.43-6.78.36-11.24.47Z"
      />
    </svg>
  )
}
